<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click="on_click()">
		<path d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1Z" :fill="fill_color" :fill-opacity="opacity"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M8 5H19C20.1 5 21 5.9 21 7V21C21 22.1 20.1 23 19 23H8C6.9 23 6 22.1 6 21V7C6 5.9 6.9 5 8 5ZM8 21H19V7H8V21Z" :fill="fill_color" :fill-opacity="opacity"/>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>
